module.exports = __webpack_public_path__ + "static/media/sweet1.ac870ac6.png";